export default __webpack_public_path__ + "static/media/locationBlack.c348af52.svg";